"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFirefox = void 0;
var isFirefox = function () { return navigator.userAgent.indexOf('Firefox') !== -1; };
exports.isFirefox = isFirefox;
